var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPreLoader = function SvgPreLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1.25s",
    values: "9.5; 9.5; 8; 8",
    keyTimes: "0; 0.25; 0.95; 1",
    keySplines: "0 0 1 1; 0 0.2 0.8 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    repeatCount: "indefinite",
    dur: "1.25s",
    values: "2; 2; 4; 4",
    keyTimes: "0; 0.25; 0.95; 1",
    keySplines: "0 0 1 1; 0 0.2 0.8 1; 0 0 1 1",
    calcMode: "spline"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1.25s",
    values: "9; 9; 2; 2",
    keyTimes: "0; 0.15; 0.85; 1",
    keySplines: "0 0 1 1; 0 0.2 0.8 1; 0 0 1 1",
    calcMode: "spline"
  }))));
};
export default SvgPreLoader;